import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const MarketButton = props => {
  const {
    children,
    href,
    variant,
    disabled,
    type,
    size,
    className,
    ...rest
  } = props;

  return React.createElement(
    href ? "a" : "button",
    {
      ...rest,
      disabled,
      className: cn(
        className,
        "market-button",
        `market-button_${size}`,
        `market-button_${type}_${variant}`
      ),
      href
    },
    children
  );
};

MarketButton.defaultProps = {
  variant: "info",
  type: "outlined",
  size: "medium",
  disabled: false,
};

MarketButton.propTypes = {
  /* Supplement as needed */
  variant: PropTypes.oneOf(["info", "primary", "error"]),
  type: PropTypes.oneOf(["outlined", "solid"]),
  size: PropTypes.oneOf(["medium"]),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default MarketButton;



// WEBPACK FOOTER //
// ./src/containers/market-button/index.js